export enum ExportType {
    FULL = 'Full',
    FILTERED = 'Filtered'
}
